module.exports = __webpack_public_path__ + "img/ep8-5b.f25c45d5.png";